export const SET_SALES_ORDER = 'SET_SALES_ORDER';
export const SET_NO_MORE_SALES_ORDER = 'SET_NO_MORE_SALES_ORDER';
export const APPEND_SALES_ORDER = 'APPEND_SALES_ORDER';
export const SET_SALES_ORDER_FILTERS = 'SET_SALES_ORDER_FILTERS';
export const SET_SALES_ORDER_NOTIFICATIONS = 'SET_SALES_ORDER_NOTIFICATIONS';
export const SET_SALES_ORDER_STATE = 'SET_SALES_ORDER_STATE';
export const SET_NOTIFICATION_AS_READ = 'SET_NOTIFICATION_AS_READ';
export const SET_READ_SALES_ORDER_NOTIFICATIONS = 'SET_READ_SALES_ORDER_NOTIFICATIONS';